var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compass",class:{
    'still': _vm.compassState === 'still',
    'vertical': _vm.compassState === 'vertical',
    'left': _vm.compassState === 'left',
    'horizontal': _vm.compassState === 'horizontal',
    'right': _vm.compassState === 'right'
  }},[_c('div',{staticClass:"compass__still"}),_c('div',{staticClass:"compass__vertical"}),_c('div',{staticClass:"compass__left"}),_c('div',{staticClass:"compass__horizontal"}),_c('div',{staticClass:"compass__right"})])}
var staticRenderFns = []

export { render, staticRenderFns }